<template>
  <div>
    <van-action-sheet v-model="actionSheet" title="所关联的消费记录">
      <div class="content">
        <simple-finance v-for="f in receipt.finances" :key="f.id" :finance="f"/>
        <br />
      </div>
    </van-action-sheet>
    <van-steps :active="status.step">
      <van-step>已申请</van-step>
      <van-step>处理中</van-step>
      <van-step>已开具</van-step>
    </van-steps>
    <div class="status-description">{{status.description}}</div>
    <van-cell-group title="基本信息">
      <van-cell title="开票金额" :value="receipt.amuont+'元'" is-link @click="actionSheet=true"/>
      <van-cell title="发票类型" :value="receipt.receiptType|typeName" />
      <van-cell title="接收电子邮箱" :value="receipt.email" />
    </van-cell-group>
    <van-cell-group title="联系方式">
      <van-cell title="姓名" :value="receipt.name" />
      <van-cell title="联系电话" :value="receipt.tel" />
    </van-cell-group>
    <van-cell-group title="开票信息">
      <van-cell title="发票抬头" :value="receipt.title"  value-class="value-class"/>
      <van-cell title="信用代码" :value="receipt.comNum"  value-class="value-class"/>
      <van-cell v-if="receipt.receiptType=='SPECIAL'" title="银行账户" :value="receipt.comAccount"  value-class="value-class"/>
      <van-cell v-if="receipt.receiptType=='SPECIAL'" title="开户行" :value="receipt.comBank"  value-class="value-class"/>
      <van-cell v-if="receipt.receiptType=='SPECIAL'" title="公司地址" :value="receipt.comAddress" value-class="value-class" />
      <van-cell v-if="receipt.receiptType=='SPECIAL'" title="公司电话" :value="receipt.comTel" />
    </van-cell-group>
    <br />
    <van-cell title="备注" :value="receipt.remark"  value-class="value-class"/>
    <div style="margin: 20px 10px">
      <van-button block type="danger" @click="del" :disabled="receipt.status != 'APPLIED' || loading">删除</van-button>
      <br/>
      <van-button block to="/invoices">返回</van-button>
    </div>
    
  </div>
</template>
<script>
import {  ActionSheet, Button, Cell, CellGroup, Icon, Loading, Step, Steps, Tag} from 'vant';
 // import { router } from '../router';
import qs from 'query-string';
import { router } from '../router';
import SimpleFinanceVue from '../components/SimpleFinance.vue';

const statusMap = {
  'APPLIED' : {
    name: '已申请',
    step: 0,
    description : '您已提交了开票申请, 我们将及时处理。在此之前, 若您发现所填内容有误, 可以删除本申请后重新填写并提交'
  },
  'CONFIRMED' : {
    name: '已确认',
    step: 1,
    description : '您的开票信息已确认, 正在开票。'
  },
  'INVOICED' : {
    name : '已开具',
    step: 2,
    description : '您的发票已开具完成。'
  }
}

export default {
  components: {
    [Button.name] : Button,
    [Tag.name] : Tag,
    [CellGroup.name] : CellGroup,
    [Cell.name] : Cell,
    [Step.name] : Step,
    [Steps.name] : Steps,
    'simple-finance' : SimpleFinanceVue,
    [Loading.name] : Loading,
    [ActionSheet.name] : ActionSheet,
    [Icon.name] : Icon
  },
  data() {
    return {
      loading : true,
      actionSheet: false,
      receipt: {}
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted(){
    const {receiptId} = qs.parse(location.search);
    this.loadRecept(receiptId);
  },
  filters : {
    typeName(type) {
      if (type == 'NORMAL') {
        return '电子普通发票'
      } else if (type == 'SPECIAL'){
        return '电子专用发票'
      } else if (type == 'E_NORMAL') {
        return '电子发票'
      }
      return '';
    }
  },
  methods: {
    async loadRecept(receiptId) {
      if (receiptId) {
        try{
          this.loading = true;
          const receipt = await this.$http.get('/receipt', {receiptId});
          this.receipt = receipt;
        } finally {
          this.loading = false;
        }
      }
    },
    async del() {
      try{
        this.loading = true;
        await this.$http.post('/receipt/del', {receiptId : this.receipt.id});
        router.push('/invoices');
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    status() {
      return statusMap[this.receipt.status] || {step: 0};
    }
  }
};
</script>

<style lang="less" scoped>
  .status-description {
    background-color: white;
    color: gray;
    font-size: 13px;
    padding: 0 10px 10px 10px;
  }
  .finance {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 10px;
    margin: 5px 0;
  }
  .finance-content {
    display: flex;
    justify-content: space-between;
  }
  .finance-title {
    color: gray;
  }
  .tips {
    color: gray;
    margin: 10px;
    font-size: 13px;
  }
  .value-class{
    flex: 4;
  }
</style>